import Swiper,  { Navigation, Pagination, FreeMode, Manipulation, Thumbs } from 'swiper'

if ($('.parts__gallery').length){


  $('.parts__gallery').each(function(){
    let block = $(this)
    let openGallery = block.find('.js-open-gallery')
    let galleryBlock = block.closest('.js-gallery-block')
    let notOpenSliders = block.find('.js-not-open-sliders')
    let galleryPopup = block.find('.js-gallery-popup')
    let galleryData = galleryBlock.find('.js-gallery-slides')
    let slides = galleryData.find('div')
    let bigSliderNotOpened = block.find('.js-gallery-slider-big-not-open')

    let gallerySwiper, gallerySwiper2
    let gallerySwiperNotOpen
    let activeSlide = 0



    //-- Not Opened Gallery Sliders --

    if (bigSliderNotOpened){

      // add slides to gallery
      slides.each(function(i, el){
        // Prepare big slide html
        let bigEl = '<div class="img-c" ><img src="'+ $(el).data('src') +'" /></div>';

        if ($(el).data('video')) {
          bigEl = '<div class="img-c" ><video width="400" controls>'+
                    '<source src="'+ $(el).data('video') +'" type="video/mp4">'+
                  '</video></div>';
        }

        if ($(el).data('youtube-video')) {
          bigEl = '<div class="img-c" ><iframe data-img-src="'+ $(el).data('youtube-video') +'" src="" ' +
                      'title="YouTube video player" frameborder="0" allowfullscreen '+
                      'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"'+
                  '</iframe></div>';
        }

        bigSliderNotOpened.find('.swiper-wrapper').append('<div class="swiper-slide">'+ bigEl +'</div>');
      })


      // Init Not Opened Slider

      gallerySwiperNotOpen = new Swiper(bigSliderNotOpened[0], {
        modules: [Navigation, Pagination, FreeMode, Manipulation, Thumbs],
        //loop: true,
        spaceBetween: 0,
        navigation: {
          nextEl: notOpenSliders.find(".swiper-button-next")[0],
          prevEl: notOpenSliders.find(".swiper-button-prev")[0],
        },
        thumbs: {
          swiper: gallerySwiperNotOpen,
        },
        initialSlide: 0,
        on: {
          slideChange: function () {
            activeSlide = this.activeIndex

            // stop prev slide video and play current left slider video
            $(this.el).find('video').each(function(i, el) {
                el.pause()
                el.currentTime = 0
            })
            let curSLide = $(this.slides[this.activeIndex])
            let video = curSLide.find('video')
            if (video.length){
                video[0].play()
            }

            // youtube video
            $(this.el).find('iframe').each(function(i, el) {
                $(this).attr('src', '')
            })
            let iframe = curSLide.find('iframe')
            iframe.attr('src', iframe.attr('data-img-src'))
          },

        },
      });


      let imgDescriptionEl = block.find('.js-description')
      setSlideDescription(0, imgDescriptionEl)

      gallerySwiperNotOpen.on('slideChange', function(){
        notOpenSliders.find('.js-current-gallery-img').text(this.activeIndex + 1)
        setSlideDescription(this.activeIndex, imgDescriptionEl)
      })


    }



    //--- Open Gallery Popup ---

    openGallery.click(function (){
      let bigSlider = block.find('.js-gallery-slider-big')
      let navSlider = block.find('.js-gallery-slider-nav')
      let initialSlide = block.data('initial-slide')
      let galleryPopup = block.find('.js-gallery-popup')

      let galleryTitle = galleryData.data('gallery-title')
      let galleryTitleEl = galleryPopup.find('.js-gallery-title')
      let galleryAuthor = galleryData.data('gallery-author')
      let galleryAuthorEl = galleryPopup.find('.js-gallery-img-author')
      let totalSlidesEl = galleryPopup.find('.js-total-gallery-img')
      let currentSlideEl = galleryPopup.find('.js-current-gallery-img')
      let imgDescriptionEl = galleryPopup.find('.js-open-description')

      if (!initialSlide) initialSlide = 0
      bigSlider.find('.swiper-wrapper').empty()
      navSlider.find('.swiper-wrapper').empty()

      // fill popup with gallery info
      totalSlidesEl.html(slides.length)
      currentSlideEl.html(activeSlide + 1)

      if (galleryTitle){
        galleryTitleEl.html(galleryTitle).show()
      } else {
        galleryTitleEl.hide()
      }
      if (galleryAuthor){
        galleryAuthorEl.html(galleryAuthor)
        galleryAuthorEl.parent().show()
      } else {
        galleryAuthorEl.parent().hide()
      }

      setSlideDescription(activeSlide, imgDescriptionEl)

      // add gallery images
      slides.each(function(i, el){
        // Prepare big slide html
        let bigEl = '<img src="'+ $(el).data('src') +'" />';

        if ($(el).data('video')) {
          bigEl = '<video width="100%" controls>'+
                    '<source src="'+ $(el).data('video') +'" type="video/mp4">'+
                  '</video>';
        }

        if ($(el).data('youtube-video')) {
          bigEl = '<iframe data-img-src="'+ $(el).data('youtube-video') +'" src="" ' +
                      'title="YouTube video player" frameborder="0" allowfullscreen '+
                      'allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"'+
                  '</iframe>';
        }

        bigSlider.find('.swiper-wrapper').append('<div class="swiper-slide">'+ bigEl +'</div>');

        // Prepare nav slide html
        let navEl = '<div class="img" style="background: url('+$(el).data('src')+') no-repeat center; background-size:cover;"></div>';
        navSlider.find('.swiper-wrapper').append('<div class="swiper-slide">'+ navEl +'</div>');
      })


      gallerySwiper = new Swiper(galleryPopup.find(".js-gallery-slider-nav")[0], {
        modules: [Navigation, Pagination, FreeMode, Manipulation, Thumbs],
        //loop: true,
        spaceBetween: 10,
        slidesPerView: 2,
        freeMode: true,
        watchSlidesProgress: true,
        breakpoints: {
          200: {
            slidesPerView: 3,
          },
          500: {
            slidesPerView: 5,
          },
          800: {
            slidesPerView: 7,
            spaceBetween: 15,
          },
          1200: {
            slidesPerView: 7,
          },
        },
      });

      gallerySwiper2 = new Swiper(galleryPopup.find(".js-gallery-slider-big")[0], {
        modules: [Navigation, Pagination, FreeMode, Manipulation, Thumbs],
        //loop: true,
        spaceBetween: 0,
        navigation: {
          nextEl: galleryPopup.find(".swiper-button-next")[0],
          prevEl: galleryPopup.find(".swiper-button-prev")[0],
        },
        thumbs: {
          swiper: gallerySwiper,
        },
        initialSlide: activeSlide,
        on: {
          slideChange: function () {
            // stop prev slide video and play current left slider video
            $(this.el).find('video').each(function(i, el) {
                el.pause()
                el.currentTime = 0
            })
            let curSLide = $(this.slides[this.activeIndex])
            let video = curSLide.find('video')
            if (video.length){
                video[0].play()
            }

            // youtube video
            $(this.el).find('iframe').each(function(i, el) {
                $(this).attr('src', '')
            })
            let iframe = curSLide.find('iframe')
            iframe.attr('src', iframe.attr('data-img-src'))
          },

        },
      });


      gallerySwiper2.on('slideChange', function(){
        currentSlideEl.html(this.activeIndex + 1)
        setSlideDescription(this.activeIndex, imgDescriptionEl)
      })


      galleryPopup.fadeIn();
      $('body').addClass('modal-open')


    }) // End open gallery


    // set slide description
    function setSlideDescription(slideIndex, el){
      let description = $(slides[slideIndex]).data('description')
      if (description){
        el.html(description).show()
      } else {
        el.html('').hide()
      }
    }

    block.find('.js-close-gallery-popup').click(function(){
      galleryPopup.fadeOut()
      gallerySwiper.destroy(1,0)
      gallerySwiper2.destroy(1,0)
      $('body').removeClass('modal-open')
    })


  })
  
}
